export type IconProps = React.HTMLAttributes<SVGElement>;

export const UpGradientIcon = (props: IconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="15" viewBox="0 0 12 15" fill="none" {...props}>
    <g clipPath="url(#clip0_11911_32743)">
      <path
        d="M11.2887 4.97177L5.9554 0.179688L0.62207 4.97177V9.3282L3.99244 6.30048V14.8464H7.91837V6.30048L11.2887 9.3282V4.97177Z"
        fill="url(#paint0_linear_11911_32743)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_11911_32743"
        x1="5.9554"
        y1="0.179687"
        x2="5.9554"
        y2="14.8464"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#176BF2" />
        <stop offset="0.52" stopColor="#01A4F9" />
        <stop offset="1" stopColor="#01A4F9" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_11911_32743">
        <rect width="10.6667" height="14.6667" fill="white" transform="translate(0.62207 0.179688)" />
      </clipPath>
    </defs>
  </svg>
);
